import React from 'react';
import { useRouteError } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AlertTriangle, RefreshCw } from 'lucide-react';

const ErrorBoundary = () => {
  const error = useRouteError();
  console.error(error);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-transparent text-white">
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center px-4"
      >
        <AlertTriangle className="w-24 h-24 text-red-500 mb-8" />
        <h1 className="text-5xl font-extrabold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-red-400 to-pink-600">
          Oops!
        </h1>
        <h2 className="text-2xl font-bold mb-6 text-gray-300">Something went wrong</h2>
        <p className="text-xl mb-4 text-gray-400 max-w-md mx-auto">
          We apologize, but an unexpected error has occurred.
        </p>
        <p className="text-gray-500 mb-8 max-w-md mx-auto overflow-hidden text-ellipsis">
          <i>{error.statusText || error.message}</i>
        </p>
        <button 
          onClick={handleRefresh}
          className="inline-flex items-center px-6 py-3 text-lg font-semibold text-white bg-gradient-to-r from-red-500 to-pink-500 rounded-full hover:from-red-600 hover:to-pink-600 transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          <RefreshCw className="mr-2" />
          Refresh Page
        </button>
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.1 }}
        transition={{ delay: 0.5, duration: 0.5 }}
        className="absolute inset-0 -z-10"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      />
    </div>
  );
};

export default ErrorBoundary;